import { Routes, Route } from "react-router-dom";
import Login from './pages/login';
import ListPage from './pages/logs';
import PrivacyPolicy from './pages/privacy-policy';

function App() {

  return (
    <div>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/list" element={<ListPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </div>
  );
}

export default App;